import Stack from '@mui/material/Stack';
import TextFieldLabel from '@shared/components/inputs/TextFieldLabel/TextFieldLabel';
import { StyledPhoneNumberInput } from '@shared/components/inputs/PhoneNumberInput/PhoneNumberInput.styles';
import FormErrorMessage from '@shared/components/feedback/FormErrorMessage/FormErrorMessage';
import type { LeadCaptureSectionProps } from '@components/LeadCaptureForm/LeadCaptureForm.types';

export const PhoneNumberField = ({ formik }: LeadCaptureSectionProps) => {
  const { values, touched, errors, setFieldValue, setFieldTouched } = formik;

  return (
    <Stack gap="10px">
      <TextFieldLabel label="Phone Number (Mobile Preferred)" variant="label.fieldMedium" />
      <StyledPhoneNumberInput
        placeholder="(123) 456-7890"
        value={values.phone}
        onChange={(value) => setFieldValue('phone', value || '')}
        onBlur={() => setFieldTouched('phone', true)}
        borderRadius="6px"
        height="41px"
        invalid={touched.phone && !!errors.phone}
        defaultCountry="CA"
        fontSize="16px"
      />
      {touched.phone && errors.phone && <FormErrorMessage>{errors.phone as string}</FormErrorMessage>}
    </Stack>
  );
};
